import { render, staticRenderFns } from "./DragResizeHandler.vue?vue&type=template&id=486d1202&scoped=true&"
import script from "./DragResizeHandler.vue?vue&type=script&lang=ts&"
export * from "./DragResizeHandler.vue?vue&type=script&lang=ts&"
import style0 from "./DragResizeHandler.vue?vue&type=style&index=0&id=486d1202&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "486d1202",
  null
  
)

export default component.exports